import script from "./ChampionshipStage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChampionshipStage.vue?vue&type=script&setup=true&lang=js"

import "./ChampionshipStage.vue?vue&type=style&index=0&id=7d3c5c05&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d3c5c05"]])

export default __exports__